

const blendHex = require('./blend');

module.exports = (color, percent) => blendHex(color, '#000000', percent);



// WEBPACK FOOTER //
// ./src/utilities/color/factories/functions/hex/darken.js